module.exports = "<div id=\"hide-menu\" class=\"btn-header pull-right\">\r\n        <span> <a (click)=\"onToggle()\" title=\"Collapse Menu\"><i\r\n                class=\"fa fa-reorder\"></i></a> </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module id = ../../../../../src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module chunks = main